import React from 'react';

import makeDeprecatedJadeStyleTemplate from 'util/makeDeprecatedJadeStyleTemplate';

export interface Popup2Props {
  title: string;
}

function Popup2({title}: Popup2Props): JSX.Element {
  return (
    <div className="modal-dialog popup">
      <div className="modal-content">
        <div className="modal-header">
          <button type="button" data-dismiss="modal" aria-hidden="true" className="close">
            &times;
          </button>
          <h4
            className="modal-title"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{__html: title}}
          />
        </div>
        <form action="#" className="popup-form">
          <div className="modal-body" />
          <div className="modal-footer" />
        </form>
      </div>
    </div>
  );
}

export default makeDeprecatedJadeStyleTemplate<Popup2Props>(Popup2);
